import axios, { AxiosResponse } from 'axios';
import { CHANGE_PASSWORD } from './endpoints';
import { Token } from '../models/Token';
import { Password } from '../models/Password';
import { DateOfBirth } from '../models/DateOfBirth';

export type ChangePasswordAPIParams = {
  password: Password;
  birthday: DateOfBirth;
  token: Token;
  uid: string | null;
};

export type ChangePasswordAPIResponse = {
  status: ChangePasswordAPIResponseStatus;
};

export type ChangePasswordAPIResponseStatus =
  | 'IDENTICAL_USERNAME_AND_PASSWORD'
  | 'INCORRECT_BIRTHDATE'
  | 'INVALID_TOKEN'
  | 'INVALID_PASSWORD_LENGTH'
  | 'INVALID_PASSWORD_SYMBOL'
  | 'SUCCESS';

export type ChangePasswordResponseStatus =
  | ChangePasswordAPIResponseStatus
  | 'TECHNICAL_ERROR';

export const changePassword = (
  password: Password,
  dateOfBirth: DateOfBirth,
  token: Token,
  customerUid: string | null,
  sourceContext: string | null,
): Promise<ChangePasswordResponseStatus> => {
  return axios
    .post<
      ChangePasswordAPIResponse,
      AxiosResponse<ChangePasswordAPIResponse>,
      ChangePasswordAPIParams
    >(
      CHANGE_PASSWORD,
      {
        password,
        birthday: dateOfBirth,
        token,
        uid: customerUid,
      },
      {
        headers: {
          'Source-Context': sourceContext,
        },
      },
    )
    .then((response) => {
      if (response.data.status !== 'SUCCESS') {
        return Promise.reject(response.data.status);
      }
      return response.data.status;
    })
    .catch((error) => {
      if (error.response?.status === 500) {
        return Promise.reject('TECHNICAL_ERROR');
      }
      return Promise.reject(error);
    });
};
